import { Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Table, IconButton, Typography } from '@mui/material';
import { FC, useMemo } from 'react';
import TableCellWithToolTip from '../../Pages/UserActivityReportTable/tableCellWithTooltip';
import './style.scss';
import { convertToSeconds, formatTimeWithMoment } from '../../common/constant';
import moment from 'moment';
import LinkIcon from "@mui/icons-material/Link";
import Loader from '../loader';
import CommentIcon from '@mui/icons-material/Comment';

type OpenProjectActivityReportTableProps = {
    isLoading: boolean;
    userActivity: any;
    handleOpenDialog: (field: string, issueKey: string, date: string) => void;
};

const OpenProjectActivityReportTable: FC<OpenProjectActivityReportTableProps> = ({ isLoading, userActivity, handleOpenDialog }) => {
    const OPEN_PROJECT_TABLE_TITLES = useMemo(() => [
        "Project", "Type", "Assignee", "Task", "Subtask", "Comment", "Work Flow",
        "Documentation confluence", "Time Estimated", "Time Spent", "Total Time Spent",
        "Feedback"
    ], []);

    return (
        <TableContainer component={Paper} className='table-container'>
            <Table stickyHeader>
                <TableHead>
                    <TableRow>
                        <TableCell align="center" sx={{ fontWeight: 700, background: "#43425d", color: "#ffffff" }} width={50}>Person</TableCell>
                        <TableCell sx={{ fontWeight: 700, background: "#43425d", color: "#ffffff" }} align='center'>Waymore project Worklogs</TableCell>
                    </TableRow>
                </TableHead>

                {isLoading ? (
                    <TableBody>
                        <TableRow>
                            <TableCell colSpan={15} align="center" sx={{ height: "50vh", verticalAlign: 'middle' }}>
                                <Loader loader={isLoading} />
                            </TableCell>
                        </TableRow>
                    </TableBody>
                ) : (
                    <TableBody>
                        {userActivity.length > 0 ? userActivity.map((user: any, userIndex: number) => {
                            const assigneeWorklogReports = user.activity['assigneeTask'] || {};
                            const reporterWorkLogsReports = user.activity['reporterTask'] || {};
                            const mergedWorklogs: Record<string, any[]> = {};

                            Object.keys(assigneeWorklogReports).forEach((date) => {
                                if (!mergedWorklogs[date]) mergedWorklogs[date] = [];
                                mergedWorklogs[date].push(...assigneeWorklogReports[date]?.openProject?.totalWorkLogsInfo.map((log: any) => ({ ...log, type: 'Worked' })));
                            });

                            Object.keys(reporterWorkLogsReports).forEach((date) => {
                                if (!mergedWorklogs[date]) mergedWorklogs[date] = [];
                                mergedWorklogs[date].push(...reporterWorkLogsReports[date]?.openProject?.totalWorkLogsInfo.map((log: any) => ({ ...log, type: 'Created' })));
                            });

                            return (
                                user.openproject === "ACTIVE" ? (
                                    <TableRow key={user.openProjectId || userIndex}>
                                        <TableCell align="center" height={100} width={100} sx={{ verticalAlign: 'center' }}>
                                            <img width={75} height={75} src={user.userProfileImage || ""} alt={user.userName || '-'} />
                                            <Typography variant='body1' padding={'10px'}>{user?.open_project_user_details?.name || "-"}</Typography>
                                        </TableCell>
                                        <TableCell sx={{ width: '100%', padding: 0 }}>
                                            <TableContainer className="inner-table-container">
                                                <Table stickyHeader>
                                                    <TableHead>
                                                        <TableRow>
                                                          <TableCell colSpan={1}></TableCell>
                                                          <TableCellWithToolTip title={'Project'} colSpan={2} />
                                                          {OPEN_PROJECT_TABLE_TITLES.slice(1, 3).map((title) => (
                                                            <TableCellWithToolTip key={title} title={title} colSpan={1}  />
                                                          ))}
                                                          {OPEN_PROJECT_TABLE_TITLES.slice(3, OPEN_PROJECT_TABLE_TITLES.length).map((title) => (
                                                            <TableCellWithToolTip key={title} title={title} colSpan={1}/>
                                                          ))}
                                                        </TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {Object.keys(mergedWorklogs).length ? Object.keys(mergedWorklogs).map((date) => (
                                                            mergedWorklogs[date].length ? (
                                                                mergedWorklogs[date].map((worklog: any, i: number) => {
                                                                    const tableCellColor = worklog.originalEstimate ? moment.duration(worklog.totalTimeSpent).asSeconds() > convertToSeconds(worklog.originalEstimate) ? 'hsla(0, 78%, 82%, .702)' : '#ffffff' : "#ffffff";

                                                                    return (
                                                                        <TableRow key={i} sx={{ background: tableCellColor }}>
                                                                            {i === 0 && (
                                                                              <TableCell
                                                                                colSpan={2}
                                                                                rowSpan={mergedWorklogs[date].length}
                                                                                align="center"
                                                                                sx={{ verticalAlign: 'middle' }}
                                                                              >{date}</TableCell>
                                                                            )}
                                                                            {i > 0 && null}
                                                                          <TableCellWithToolTip title={`${worklog.projectDetails.key}-${worklog.projectDetails.name}`} colSpan={1} />
                                                                          <TableCellWithToolTip title={`${worklog.type}`} colSpan={1} />
                                                                          <TableCellWithToolTip title={`${worklog.assignee}`} colSpan={1} />
                                                                          <TableCellWithToolTip link={worklog.issueType === "Task" ? worklog.issueLink || "" : worklog.parentTaskDetails.issueLink || ""} description={worklog.issueType === "Task" ? worklog.issueKey || "-" : worklog.parentTaskDetails.issueKey || "-"} title={worklog.issueType === "Task" ? worklog.issueSummary || "-": worklog.parentTaskDetails.issueSummary || "-"} colSpan={1}/>
                                                                          <TableCellWithToolTip link={worklog.issueType === "Task" ? "" : worklog.issueLink} description={worklog.issueType === "Task" ? "-" : worklog.issueKey} title={worklog.issueType === "Task" ? "-" : worklog.issueSummary} colSpan={1} />
                                                                          <TableCell align='center' colSpan={1}>
                                                                            <IconButton onClick={() => handleOpenDialog("comments", worklog.issueKey || "", date)}>
                                                                                <CommentIcon />
                                                                            </IconButton>
                                                                          </TableCell>
                                                                          <TableCellWithToolTip title={worklog.workflow || '-'} colSpan={1}  />
                                                                          <TableCell align='center' colSpan={1}>
                                                                          {worklog.confluenceLink ? <a href={worklog.confluenceLink} target="_blank" rel="noreferrer"><LinkIcon style={{ color: '#188bfd' }} /></a> : <>-</>}
                                                                          </TableCell>
                                                                          <TableCellWithToolTip title={worklog.originalEstimate || "-"} colSpan={1}  />
                                                                          <TableCellWithToolTip title={formatTimeWithMoment(worklog.totalTimeSpentToday) || "-"} colSpan={1}  />
                                                                          <TableCellWithToolTip title={formatTimeWithMoment(worklog.totalTimeSpent) || "-"} colSpan={1} />
                                                                          <TableCellWithToolTip title="-" colSpan={1} />
                                                                        </TableRow>
                                                                    );
                                                                })
                                                            ) : (
                                                                <TableRow>
                                                                    <TableCell colSpan={15} align="center">No Worklogs available for {date}</TableCell>
                                                                </TableRow>
                                                            )
                                                        )) : (
                                                            <TableRow>
                                                                <TableCell colSpan={15} align="center">No Worklogs available</TableCell>
                                                            </TableRow>
                                                        )}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer>
                                        </TableCell>
                                    </TableRow>
                                ) : null
                            );
                        }) : (
                            <TableRow>
                                <TableCell colSpan={15} align="center">No Data Found</TableCell>
                            </TableRow>
                        )}
                    </TableBody>
                )}
            </Table>
        </TableContainer>
    );
};

export default OpenProjectActivityReportTable;
